module.exports = __webpack_public_path__ + "static/media/Tpocket_Marchio.11c4547b.png";